export default __webpack_public_path__ + "static/media/logo-partner-5.c4859298.png";